module.exports = __webpack_public_path__ + "f955663ed98767df63d2ecb1be242b90.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/carousel/qello/5.png
// module id = 852
// module chunks = 0